<template>
  <div class="maker-cart-guide-page">
    <HeroSection
      title="Educator's Guide"
      subtitle="Guide for illustrates how the Makercart ethos can enhance classroom."
      background-color="#00925e"
      background-image="/images/maker-cart/hero-banner.svg"
      background-image-mobile="/images/maker-cart/hero-banner-mobile.svg"
      illustration-image="/images/maker-cart/makercart-catalog-illustration.svg"
      illustration-alt="Makercart Catalog"
    />

    <div class="main-content mt-5 mb-5 px-4 pb-5">
      <div class="text-center mb-5">
        <img
          src="/images/maker-cart-guide/teachers-day-bro.svg"
          alt="Teachers Image"
          class="x-teachers-image"
        />
      </div>

      <h1 class="color-primary fw-bold mb-4" style="font-size: 32px">
        Congratulations on the purchase of your new Makercart!
      </h1>

      <p class="mb-4 text-left fs-5" style="color: #4a4a4a">
        This guide will get you started on the ethos behind the Makercart, and
        how you can use it to transform learning in your classroom.
        <br />
        <span class="mt-2 d-inline-block"
          >Get started below - we can't wait to see what you'll accomplish with
          your new Cart!</span
        >
      </p>

      <p class="mb-5 text-left fs-5" style="color: #4a4a4a">
        This Educator's Guide will be most helpful for educators new to
        facilitating a maker activity, although more experienced educators will
        find useful tips as well. It includes advice on what you can do before,
        during, and after the maker activity, sample guiding prompts, and more.
        These tips are a compilation from the implementation of Maker programs
        in different schools, through observation and feedback.
      </p>

      <div class="x-guide-button-wrapper">
        <ActionButton class="x-guide-button--blue" @click="goToGuide">
          Go to Educator's Guide
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import HeroSection from "@/components/common/HeroSection.vue";
import ActionButton from "@/components/common/ActionButton.vue";

const router = useRouter();

const goToGuide = () => {
  router.push({ name: "MakerCartGuide1Page" });
};
</script>

<style scoped>
.maker-cart-guide-page {
  font-family: "League Spartan", sans-serif;
}
.color-primary {
  color: var(--primary-blue);
}
.main-content {
  margin: 0 auto;
}

.x-teachers-image {
  width: 100%;
  max-width: 500px;
  height: auto;
}

.x-guide-button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.x-guide-button--blue {
  color: white;
  background-color: var(--primary-blue);
  transition: background-color 0.3s ease;
}

.x-guide-button--blue:hover {
  background-color: #012a47;
}

@media (max-width: 768px) {
  .x-guide-button-wrapper {
    justify-content: center;
  }
}
</style>
